<template>
    <div>
        <b-modal id="modal-Agent-Distributors" size="lg" class="modal-form" title="Distributor Information" @hidden="CLEAR_DATA_AGENTS_DISTRIBUTOR()" centered hide-footer>
            <b-row class="mb-4">
                <b-col md="6">
                    <div class="pb-1"><strong>Distributor Name :</strong> {{agents_distributor.name}}</div>
                    <div class="pt-1"><strong>Email :</strong> {{agents_distributor.email}}</div>
                </b-col>
                <b-col md="6">
                    <div class="pb-1"><strong>Total Agents :</strong> {{agents_distributor.agents.length}} Agents</div>
                    <div class="pt-1"><strong>Total Slots :</strong> {{agents_distributor.slots}} Slots</div>
                </b-col>
            </b-row>

            <h6 class="border-top pt-4 mb-3">List Agent</h6>

            <div class="table-responsive bdr-15">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Status</th>
                            <th>Total Event</th>
                            <th>Created Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="data in agents_distributor.agents" :key="data.id" v-on:click="editAgents(data)">
                            <td>{{data.name}}</td>
                            <td>{{data.email}}</td>
                            <td>
                                <label v-if="data.is_active === 'true'" class="badge badge-success"><i class="uil uil-check"></i> Active</label>
                                <label v-if="data.is_active === 'false'" class="badge badge-danger"><i class="uil uil-times"></i> Not Active</label>
                            </td>
                            <td><label class="badge badge-primary">{{data.events_count}} Event</label></td>
                            <td>{{data.created_at | formatDate}}</td>
                        </tr>
                    
                    </tbody>
                    
                </table>
                <p v-if="agents_distributor.agents.length === 0" class="text-center no-data">Agents data not found</p>
            </div>
        </b-modal>

        <b-modal id="modal-Add-Slots" class="modal-form" title="Add Slots Distributor" @hidden="CLEAR_DATA_AGENTS_DISTRIBUTOR()" centered hide-footer>
            <b-row class="mb-4">
                <b-col md="7">
                    <div class="pb-1"><strong>Name :</strong> {{agents_distributor.name}}</div>
                    <div class="pt-1"><strong>Email :</strong> {{agents_distributor.email}}</div>
                </b-col>
                <b-col md="5">
                    <div class="pb-1"><strong>Total Agents :</strong> {{agents_distributor.agents.length}} Agents</div>
                    <div class="pt-1"><strong>Total Slots :</strong> {{agents_distributor.slots}} Slots</div>
                </b-col>
            </b-row>

            <ValidationObserver ref="form">
                <validation-provider rules="required|min_value:1" v-slot="{ errors }">
                    <div class="form-group">
                        <label>Slot</label>
                        <input v-model="slots" type="number" class="form-control" name="name">
                        <div class="invalid-input">{{ errors[0] }}</div>
                        <small>* Make sure you have enough slots, because they will be cut from your slots. Your Slot cannot Transfer Back to You from Agent, Make sure the value is right.</small>
                    </div>
                </validation-provider>

                <div class="button-modal text-right">
                    <button v-on:click="addSlotsDistributor(agents_distributor.id)" type="button" class="btn btn-new"  v-bind:class="loading ? 'btn-progress' : ''">
                        Add Slots
                    </button>
                </div>
            </ValidationObserver>
        </b-modal>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import moment from 'moment'

    import {ValidationProvider, ValidationObserver} from "vee-validate";

    export default{
        data(){
            return{
                loading:false,
                slots:null,
            }
        },
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        computed: {
            ...mapState('DistributorsControl', {
                formdata: state => state.formdata,
                agents_distributor: state => state.agents_distributor
            }),
        },
        filters: {
            formatDate: function(val){
                if(val){
                    return moment(String(val)).format('DD MMMM YYYY')
                }else{
                    return '-'
                }
            },
        },
        methods: {
            ...mapActions('DistributorsControl', ['updateSlotsDistributors']),
            ...mapMutations('DistributorsControl', ['CLEAR_DATA_AGENTS_DISTRIBUTOR']),
            
            addSlotsDistributor: function(id) {
                this.$refs.form.validate().then(success => {
                    if (!success) {
                        setTimeout(() => {
                            const errors = Object.entries(this.$refs.form.errors)
                                .map(([key, value]) => ({ key, value }))
                                .filter(error => error["value"].length);
                            this.$refs.form.refs[errors[0]["key"]].$el.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }, 100);
                    }else{
                        this.loading = true

                        var form = {
                            slots: this.slots,
                            id: id
                        }
                        
                        this.updateSlotsDistributors(form).then(() => {
                            this.loading = false
                            this.$bvModal.hide('modal-Add-Slots')
                            this.$emit('getDistributors');
                            this.slots = null
                            this.$toast.success('Successfully Updated Slots')
                        }) 
                    }
                });
            }
        }
    }
</script>
